export const bulkContractAddress = '0x846fbbA4D381445cb649299900707E1de3594279'
